import { useLazyQuery, buildChangeLog } from '@gimlite/common';
import { useEffect, useMemo } from 'react';
import { Query } from '../../client/graphql';
import { historiesGql } from '../../common/gql/histories.gql';
import {
  Timeline,
  TimelineGroup,
} from '../../components/timeline/timeline.component';
import { DateTime } from 'luxon';
import { Icon, Popover } from '@gimlite/ui-v1';

export type ContractHistoryListProps = {
  contractId?: string;
};

export const ContractHistoryList = ({
  contractId,
}: ContractHistoryListProps) => {
  const [historiesCall, historiesState] = useLazyQuery(historiesGql, {
    variables: {
      page: 1,
      limit: 10,
      entityId: contractId,
      entityType: 'contract',
      consumer: 'OSP',
    },
  });

  const histories = useMemo<Query['histories'] | null>(() => {
    if (!historiesState.data) return null;

    return 'histories' in historiesState.data
      ? historiesState.data.histories
      : null;
  }, [historiesState.data]);

  useEffect(() => {
    console.log('🚀 ~ useEffect ~ contractId:', contractId);

    historiesCall({
      variables: {
        page: 1,
        limit: 10,
        entityId: contractId,
        entityType: 'contract',
        consumer: 'OSP',
      },
    });
  }, [contractId, historiesCall]);

  return (
    <>
      <TimelineGroup config={{ height: 'medium', width: 'full' }}>
        {histories?.list?.map((history) => (
          <div key={history._id} style={{ position: 'relative' }}>
            <Timeline
              config={{
                color: 'success',
              }}
              data={{
                iconText:
                  history.doer?.type === 'operator'
                    ? 'O'
                    : history?.doer?.type === 'pool_admin'
                    ? 'T'
                    : 'M',
                title: history.tag,
                date: history.createdAt
                  ? DateTime.fromISO(history.createdAt).toLocaleString(
                      DateTime.DATETIME_SHORT_WITH_SECONDS,
                    )
                  : '-',
                extra: history.doer?.firstName
                  ? `${history.doer?.firstName}. ${
                      history.doer?.lastName?.slice(0, 1) ?? ''
                    }`
                  : history.doer?.type,
                actions: (() => {
                  if (
                    history.payload?.before &&
                    history.payload?.after &&
                    history.payload?.userId &&
                    history.payload?.action &&
                    history.payload?.id
                  ) {
                    const changeLog = buildChangeLog({
                      before: history.payload.before,
                      after: history.payload.after,
                      userId: history.payload.userId,
                      action: history.payload.action,
                      id: history.payload.id,
                    });
                    return (
                      <Popover
                        data={
                          <div
                            style={{
                              padding: 8,
                              minWidth: 200,
                              maxWidth: 300,
                              wordBreak: 'break-word',
                            }}
                          >
                            <div>{changeLog.message}</div>
                          </div>
                        }
                        config={{ placement: 'right', trigger: 'hover' }}
                      >
                        <span className="history-list__eye-icon">
                          <Icon
                            config={{
                              type: 'faEyeSolid',
                              color: 'info',
                              size: 'xsmall',
                            }}
                          />
                        </span>
                      </Popover>
                    );
                  }
                  return undefined;
                })(),
              }}
            />
          </div>
        ))}
      </TimelineGroup>
    </>
  );
};
